// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Back',
    title: 'Orders',
    pdf: 'PDF',
    detail: 'Detail',
    order_time: 'Order Date',
    booking_number: 'Booking Number',
    ticket_total: 'Ticket Total',
    total: 'Total',
    support_status: 'Support',
    email: 'Email',
    status: 'Status',
    cancelled_at: 'Cancelled At',
    template: 'Template',
    customer_name: 'Name',
    phone_number: 'Phone',
    created_at: 'Order Date',
    country: 'Country',
    locale: 'Lang.',
    trips: 'Trips',
    no_record: 'No order found according to your search.',
    ticket_total: 'Ticket Total',
    created_at_min: 'Order Date Min',
    created_at_max: 'Order Date Max',
    cancelled_at_min: 'Cancelled Date Min',
    cancelled_at_max: 'Cancelled Date Max',
    depart_at_min: 'Travel Date Min',
    depart_at_max: 'Travel Date Max',
    empty_filter: 'Empty Filters',
    reload: 'Reload',
    company_name: 'Company Name',
    route_name: 'Route Name'
}
